import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InvestorService } from 'src/services/investor.service';

@Component({
  selector: 'app-add-investor-modal',
  templateUrl: './add-investor-modal.component.html',
  styleUrls: ['./add-investor-modal.component.scss'],
})
export class AddInvestorModalComponent implements OnInit {
  display: boolean = false;
  loading: boolean = false;
  errorMessage: string | null = null;
  addInvestorForm: FormGroup;

  @Output() investorAdded = new EventEmitter<void>();

  constructor(
    private fb: FormBuilder,
    private investorService: InvestorService,
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.addInvestorForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      mobile_number: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      pan: ['', [Validators.required, Validators.pattern(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i)]],
      dob: [null, Validators.required],
      gender: ['', Validators.required],
    });
  }

  showDialog() {
    this.display = true;
  }

  hideDialog() {
    this.display = false;
    this.addInvestorForm.reset();
    this.loading = false;
    this.errorMessage = null;
  }

  onSubmit() {
    this.errorMessage = null;

    if (this.addInvestorForm.invalid) {
      this.addInvestorForm.markAllAsTouched();
      return;
    }

    const formData = { ...this.addInvestorForm.value };

    if (formData.dob instanceof Date) {
      const year = formData.dob.getFullYear();
      const month = String(formData.dob.getMonth() + 1).padStart(2, '0');
      const day = String(formData.dob.getDate()).padStart(2, '0');
      formData.dob = `${year}-${month}-${day}`;
    }

    formData.pan = formData.pan?.toUpperCase();

    this.loading = true;
    this.investorService.addInvestor(formData).subscribe({
      next: () => {
        this.investorAdded.emit();
        this.hideDialog();
      },
      error: (err: any) => {
        this.loading = false;
        this.errorMessage =
          err?.error?.message ?? 'Something went wrong. Please try again.';
      },
    });
  }
}
